import { ApiService } from "@/api/services/ApiService";
import { IProject } from "@/lib/types";

// ---------------------- Service

export class ProjectService {
  // --------- Variables

  private static API_URL = import.meta.env.VITE_API_URL;

  // --------- Methods

  static async getAllProjects(): Promise<IProject[]> {
    return await ApiService.sendRequest(`${this.API_URL}/api/projects`, {
      method: "GET",
    });
  }
}
